import Syncable from '@/syncing/Syncable.js'
import _ from 'lodash'
import { useCamerasStore } from '@/store/cameras.js'
import { isBarnPrecondition, isInstanceNotStalePrecondition, isLoggedInPrecondition, isOnlinePrecondition } from '@/syncing/SyncablePreconditions.js'

class CamerasSyncable extends Syncable {
  constructor(globalUniqueIdentifier) {
    super(globalUniqueIdentifier, 1000 * 60 * 10, [isBarnPrecondition, isOnlinePrecondition, isLoggedInPrecondition, isInstanceNotStalePrecondition])
  }

  hasInitialData() {
    const data = useCamerasStore().getCameras(this.globalUniqueIdentifier)
    if (!data) {
      return false
    }
    if (data.length === 0) {
      return false
    }
    return true
  }

  async workload() {
    const cameras = await useCamerasStore().loadCameras(this.globalUniqueIdentifier)
    if (cameras === null) return false
    const currentCameras = useCamerasStore().getCameras(this.globalUniqueIdentifier)
    if (currentCameras && _.isEqual(currentCameras, cameras)) return
    useCamerasStore().cameras[this.globalUniqueIdentifier] = cameras
  }

  static getSyncableHandle() {
    return 'cameras'
  }
}

export default CamerasSyncable
